import { WidgetFeature } from 'enums/WidgetFeature';
import { DefaultRootState } from 'react-redux';
import { selectFeatureEnabled } from 'state/features/features.selectors';
import { selectIsAuthUsed } from 'state/parameters/parameters.selectors';

export const selectChannelHasReactions = (state: DefaultRootState) => {
    return (
        Array.isArray(state.connection.channelInfo?.reactions) &&
        state.connection.channelInfo.reactions.length > 0
    );
};

export const selectChannelReactions = (state: DefaultRootState) => {
    return state.connection.channelInfo?.reactions ?? null;
};

export const selectChannelClientSendVoice = (state: DefaultRootState) => {
    return Boolean(state.connection.channelInfo?.client_send_voice);
};

export const selectChanneInformationBanner = (state: DefaultRootState) => {
    return state.connection.channelInfo?.information_banner;
};

export const selectIsExecutable = (state: DefaultRootState) => {
    const authed = state.connection.authed;
    const isAuthUsed = selectIsAuthUsed(state);
    const unlimitedAuth =
        selectFeatureEnabled(state, WidgetFeature.LimitUnauthorizedFeatures) === false;

    return authed && (isAuthUsed || unlimitedAuth);
};
